"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemovedMap = void 0;
const Removed_1 = require("../domain/Removed");
const Mapper_1 = require("../infra/Mapper");
const TimestampMap_1 = require("./TimestampMap");
class RemovedMap extends Mapper_1.Mapper {
    static toDomain(raw, ref, runValidation) {
        if (runValidation) {
            if (!Removed_1.Removed.validate(raw, ref).pass)
                return null;
        }
        const domainObject = !raw
            ? null
            : Removed_1.Removed.create({
                appType: raw.appType || Mapper_1.AuthMock.appType,
                comment: raw.comment,
                removedAt: TimestampMap_1.TimestampMap.toDomain(raw.removedAt),
                removedBy: raw.removedBy,
            });
        return domainObject;
    }
    static toDTO(d) {
        const res = {
            appType: d.value.appType.value,
            comment: d.value.comment,
            removedAt: d.value.removedAt.value,
            removedBy: d.value.removedBy,
        };
        return res;
    }
}
exports.RemovedMap = RemovedMap;
//# sourceMappingURL=RemovedMap.js.map